import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PermissionService } from 'src/app/services/permission.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-menu-role',
  templateUrl: './menu-role.component.html',
  styleUrls: ['./menu-role.component.scss']
})
export class MenuRoleComponent implements OnInit {
  roles: String[] = [];
  public navImage = CONSTANTES.navBarImage;

  constructor(private spinner: NgxSpinnerService,private toastr: ToastrService, private permissionService: PermissionService, private router: Router,
    private authService: AuthenticationService) { }

  ngOnInit() {
    this.spinner.show();
    try {
      jQuery.getScript(CONSTANTES.menu);
    } catch (Error) {
      this.router.navigate(['login']);
    }

    this.permissionService.getRoleUser(localStorage.getItem("nid")).subscribe(
      data => {
        if (getToken(data)) {
          for (let i = 0; i < data.roles.length; i++) {
            this.roles.push(data.roles[i].name);
          }
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS", "ERROR");
      }  
    )

    this.spinner.hide();
  }

  selectRole(rol: string){
    localStorage.setItem("role", rol);
    this.router.navigate(['home']);          
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

}
